import type { ReactNode } from "react";

/**
 * The house async-save rainbow, underline variant: a 1px hue-cycling line on a
 * control's bottom edge while `busy`. A replaced element (a `<select>` or
 * `<input>`) can't carry the `::after` the effect is drawn with, so it rides
 * this wrapper instead — pass the control as `children` and a layout
 * `className` (e.g. `inline-block`, or `min-w-0 flex-1`). The full-ring
 * counterpart for rounded controls lives on SegmentedToggle / Switch.
 */
export function RainbowUnderline({
  busy,
  className = "",
  children,
}: {
  /** True while the save is in flight (held a beat after, per the caller). */
  busy: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <span
      className={`rainbow-underline ${busy ? "rainbow-underline-busy" : ""} ${className}`}
    >
      {children}
    </span>
  );
}
